import { actionKitImpFunction } from '../../../../../components/ozmoit/common';
import {
  ExportStudentsRiskHistoryParams,
  exportStudentsRiskHistory,
  getFiltersOptions,
  getStudentsRiskHistory,
  getStudentsRiskHistoryDetails,
  createStudentRiskActionRecord,
  createStudentRiskAction,
} from '../api';
import {
  StudentsRiskHistoryParams,
  StudentsRiskHistoryDetailsRouteParams,
} from '../types';

const getFiltersOptionsAction = actionKitImpFunction(async () => {
  const response = await getFiltersOptions();
  if (response.error) {
    throw new Error('Error fetching form data');
  }
  const { data } = response;
  return data;
});

const StudentsRiskHistoryAction = actionKitImpFunction(
  async (queryParams: StudentsRiskHistoryParams) => {
    const response = await getStudentsRiskHistory(queryParams);
    if (response.error) {
      throw new Error('Error fetching form data');
    }
    const { data } = response;
    return data;
  },
);

const StudentsRiskHistoryDetailsAction = actionKitImpFunction(
  async (params: Partial<StudentsRiskHistoryDetailsRouteParams>) => {
    const response = await getStudentsRiskHistoryDetails(params);
    if (response.error) {
      throw new Error('Error fetching form data');
    }

    return response.data;
  },
);

const exportStudentsRiskHistoryAction = actionKitImpFunction(
  async (params: ExportStudentsRiskHistoryParams) => {
    const response = await exportStudentsRiskHistory(params);
    if (response.error) {
      throw new Error('Error exporting students risk history');
    }
    return response.data;
  },
);

const createStudentRiskActionAction = actionKitImpFunction(
  async (params: Record<string, string>) => {
    const response = await createStudentRiskAction(params);
    if (response.error) {
      throw new Error('Error creating student risk action');
    }
    return response.data;
  },
);

const createStudentRiskActionRecordAction = actionKitImpFunction(
  async (params: Record<string, string>) => {
    const response = await createStudentRiskActionRecord(params);
    if (response.error) {
      throw new Error('Error creating student risk action record');
    }
    return response.data;
  },
);

export {
  getFiltersOptionsAction,
  StudentsRiskHistoryDetailsAction,
  StudentsRiskHistoryAction,
  createStudentRiskActionAction,
  createStudentRiskActionRecordAction,
  exportStudentsRiskHistoryAction,
};
